export default "__VITE_ASSET__BaYDhVv$__"